import React, {useId, useLayoutEffect, useRef} from 'react';
import './styles.css';

type TextAreaUITypes = 'standart' | 'box';

interface Props {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  heading?: string;
  className?: string;
  fieldError?: boolean;
  isMandatory?: boolean;
  uiType?: TextAreaUITypes;
  maxCharacters?: number;
  disabled?: boolean;
  maxHeight?: number;
}

const TextAreaInput = React.memo(
  ({
    value,
    onChange,
    placeholder,
    heading,
    className,
    fieldError,
    isMandatory,
    uiType,
    maxCharacters,
    disabled,
    maxHeight,
  }: Props) => {
    const textbox = useRef<any>(null);
    const id = useId();

    const adjustHeight = () => {
      if (textbox && textbox.current) {
        const currentHeight = textbox.current.style.height.replace('px', '');
        textbox.current.style.height =
          maxHeight && textbox.current.scrollHeight > maxHeight
            ? `${maxHeight}px`
            : currentHeight > textbox.current.scrollHeight
            ? `${currentHeight}px`
            : `${textbox.current.scrollHeight}px`;
      }
    };

    useLayoutEffect(adjustHeight, [value]);

    const handleKeyDown = (e: any) => {
      onChange(e.target.value);
      adjustHeight();
    };

    const getBaseClass = () => {
      switch (uiType) {
        case 'box':
          return 'TextAreaBoxInput';
        default:
          return 'TextAreaInput';
      }
    };

    return (
      <div className={className}>
        <p className="TextAreaHeading">
          {heading}
          {isMandatory ? <span className="MandatoryIndicator">*</span> : ''}
        </p>
        <div className="TextAreaContainer">
          <textarea
            id={id}
            disabled={disabled}
            value={value}
            ref={textbox}
            onChange={handleKeyDown}
            placeholder={placeholder}
            className={`${getBaseClass()} ${fieldError ? 'FieldError' : ''} ${
              disabled ? 'DisabledInput' : ''
            }`}
            maxLength={maxCharacters}
          />
        </div>
        <div className="TextAreaCharactersCountContainer">
          {maxCharacters ? (
            <div className="TextAreaMaxCharacters">
              <span>
                {value.length} / {maxCharacters}
              </span>
            </div>
          ) : (
            <div />
          )}
        </div>
      </div>
    );
  },
);

export default TextAreaInput;
